import { render } from "./c.vue?vue&type=template&id=4e477299&lang=pug"
import script from "./c.vue?vue&type=script&lang=js"
export * from "./c.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__